/* eslint-disable import/extensions */
/* eslint-disable no-unsafe-optional-chaining */
import { useContext, useEffect, useRef, useState, useCallback } from 'react'
import { UserContext } from 'context/userContext'
import { IResponse } from 'interfaces'
import {
  ColorPicker,
  InvestCard,
  Slider,
  UploadImg,
  ButtonNext,
  Path,
} from 'components/index'
import { adjustColor } from 'helper/secondColor'
import { Form } from '@unform/web'
import { dateToTimestamp } from 'helper/utils'
import useFetch from 'hooks/useFetch'
import { Container, InputError } from './style'

const now = new Date()

interface IProps {
  path?: string
}

interface IData {
  contractList?: any[]
  documentList?: any[]
  header?: File
  [key: string]: any
}

export default function ResumoCaptacao({ path }: IProps) {
  const {
    data,
    setData,
    requestFn,
    setPreview,
    toggleCap,
    setPage,
    page,
    feedback,
  } = useContext(UserContext)
  const formRef = useRef<HTMLFormElement | any>(null)
  const [item, setItem] = useState<any>({})
  const api = useFetch()
  const formData = new FormData()
  const [headerError, setHeaderError] = useState<boolean | string>(false)

  const buildFormData = () => {
    formData.delete('documentList')
    formData.delete('contractList')
    formData.delete('attachmentList')

    Object.entries(data).forEach(([key, value]: [string, any]) => {
      if (
        key === 'contractList' ||
        key === 'documentList' ||
        key === 'attachmentList'
      ) {
        value.forEach(([name, file]: [string, File]) =>
          formData.append(key, file, name)
        )
        return
      }
      if (key === 'header') return formData.set(key, value, value.name)
      if (typeof value === 'object') value = JSON.stringify(value)
      else if (!value) return
      formData.set(key, value)
    })
  }

  const handleChange = useCallback(
    (key: string, value: any) => {
      setData((prev: IData) => ({ ...prev, [key]: value }))
    },
    [setData]
  )

  // useEffect(() => {
  //   console.log(data)
  // }, [data])
  // FORMATA O DATA PARA PEGAR SO O VALUE DE CHAVES SELECT
  // ex:  type: { label: 'Cotas imobiliárias', value: 'SPE' } para { type: 'SPE' }
  const extractValues = (obj: any) => {
    if (!obj) return {}
    const extractedObj: any = {}

    Object.entries(obj).forEach(([key, value]: [string, any]) => {
      if (!value) return
      if (typeof value === 'object' && 'value' in value) {
        extractedObj[key] = value.value
      } else {
        extractedObj[key] = value
      }
    })

    return extractedObj
  }

  useEffect(() => {
    // setPreview('')
    // formData.delete('documentList')
    // const datesForm = {
    //   releaseAt: dateToTimestamp(data?.releaseAt),
    //   startedAt: dateToTimestamp(data?.startedAt),
    //   tradeAt: dateToTimestamp(data?.tradeAt),
    //   createdAt: dateToTimestamp(data?.createdAt),
    // }

    // if (toggleCap === 'Proposta personalizada') {
    //   delete datesForm.releaseAt
    // }
    setData((prev: any) => ({
      ...prev,
      // ...extractValues(prev),
      color: [
        toggleCap === 'Proposta personalizada' ? '#DF7A58' : '#DF7A58',
        toggleCap === 'Proposta personalizada'
          ? adjustColor('#DF7A58', 0.8, 0.4)
          : adjustColor('#DF7A58', 0.8, 0.4),
      ],
      opacity: data?.opacity || 0.5,
      // ...datesForm,
    }))
    setItem({
      id: 'asdasdsasd',
      chart: {
        sectionList: [
          {
            rate: 0.75,
            title: '',
            color:
              toggleCap === 'Proposta personalizada' ? '#0f0f0f' : '#DF7A58',
          },
        ],
        title: '75%',
        subtitle: 'Captados',
      },
      style: {
        color: [
          toggleCap === 'Proposta personalizada' ? '#DF7A58' : '#DF7A58',
          toggleCap === 'Proposta personalizada'
            ? '#0f0f0f'
            : adjustColor('#DF7A58', 0.8, 0.4),
        ],
        icon: '',
        image: {
          opacity: 50,
        },
      },
      releaseAt: data?.releaseAt || new Date(),
      name: data?.name,
      label: data?.enterpriseId ? 'Investimento mínimo' : null,
      value: data?.enterpriseId ? data?.minInvest : null,
    })
  }, [])

  const handleNext = () => {
    setHeaderError(false)

    if (!data?.header) return setHeaderError('Campo obrigatório')
    feedback.current = { title: 'Empreendimento criado!', error: false }
    requestFn.current = async () => {
      try {
        buildFormData()
        const response: IResponse = await api.fetch(
          'post',
          formData,
          '/gestor/enterprise',
          { 'Content-type': 'multipart/form-data' }
        )
        // setPreview('')
        return response
      } catch (err: any) {
        return err
      }
    }

    setPage((prev: any) => prev + 1)
  }

  return (
    <Container>
      <Path className="path">
        <span className="path">{path}</span>
      </Path>
      <h1 className="new-token-title">
        Criar Layout da Nova Captação ou Empreendimento
      </h1>
      <div className="new-token-container">
        <div className="new-token-container-left">
          <div className="new-token-subtitle">
            <h4>Cores</h4>
          </div>
          <div className="color-picker-container">
            <ColorPicker
              initColor={
                toggleCap === 'Proposta personalizada' ? '#0f0f0f' : '#DF7A58'
              }
              disabled
              getColor={(color: string) => console.log(color)}
            />
            <ColorPicker
              placeholder="Cor Secundária gerada"
              disabled
              initColor={
                toggleCap === 'Proposta personalizada'
                  ? '#0f0f0f'
                  : adjustColor('#DF7A58', 0.8, 0.4)
              }
              getColor={() => console.log('second')}
            />
          </div>

          <div className="color-picker-container">
            <div>
              <h4 className="new-token-subtitle">Imagem</h4>
              <span className="span-1">Selecione um arquivo</span>
              <span className="span-2"> ou arraste e solte aqui</span>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Form ref={formRef} onSubmit={handleNext}>
                  <UploadImg
                    file={data?.header}
                    error={headerError}
                    name="header"
                    onChangeFile={(file: any) => {
                      handleChange('header', file)
                      setHeaderError(false)
                    }}
                  >
                    Upload de imagem
                  </UploadImg>
                </Form>
                {headerError && <InputError>{headerError}</InputError>}
              </div>
              <div className="recomendations-container">
                <span className="recomendations">Recomendações do upload:</span>
                <span className="recomendations-item">
                  Arquivo de imagem: JPG ou PNG
                </span>
                <span className="recomendations-item">
                  Tamanho da imagem: 300px x 130px
                </span>
              </div>
            </div>

            <div>
              <h4 className="new-token-subtitle">Opacidade da imagem</h4>
              <span className="span-3">Deslize</span>
              <span className="span-2">
                para ajustar o nível de opacidade da imagem
              </span>
              <Slider
                defaultValue={data?.opacity * 100 || 50}
                getStep={(e: any) => {
                  handleChange('opacity', Number(e) / 100)
                  setItem((prev: any) => ({
                    ...prev,
                    style: {
                      ...prev.style,
                      image: {
                        opacity: Number(e),
                      },
                    },
                  }))
                }}
              />
            </div>
          </div>
        </div>
        <div className="new-token-container-right">
          <span className="preview">Preview da captação no app Atto</span>
          <InvestCard
            item={item}
            i={1}
            onClick={() => console.log('testewertetet')}
            shadow
            isPreview
            isEnterprise={!data?.enterpriseId}
          />
        </div>
      </div>
      <ButtonNext
        isAdvance
        advancePage={() => handleNext()}
        isBack
        backPage={() => setPage((prev) => prev - 1)}
      />
    </Container>
  )
}
